export const DateTimePickerStyleProps = {
    display: 'flex',
    flexDirection: 'column',
    height: {
        desktop: '23rem',
        tablet: '21rem',
        mobileXL: '20rem',
        base: '17.5rem',
    },
    minWidth: {
        desktop: '23rem',
        tablet: '21rem',
        mobileXL: '20.5rem',
        base: '19rem',
    },
    paddingX: {base: '1rem', mobileXL: '2.5rem'},
    paddingY: {
        desktop: '3rem',
        tablet: '2rem',
        mobileXL: '1.5rem',
        base: '1rem',
    },
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'accent',
};

export const InputGroupStyleProps = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginY: {mobileXL: '.5rem', base: '.5rem'},
    marginX: 'none',
};

export const ButtonContainerStyleProps = {
    display: 'flex',
    justifyContent: {mobileXL: 'start', base: 'center'},
};

export const buttonStyleProps = {
    marginTop: {mobileXL: '1rem', base: '.5rem'},
    variante: 'primary',
    textDecoration: 'none',
    width: '10rem',
};
